/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import Button from "../../components/ButtonUse";
import { useState } from "react";
import axios from "axios";
import { CircularProgress } from "@mui/material";
// Data

// Dashboard components

function AddNewPrice() {
  const[formData,setFormData]=useState({});
  const[isLoading,setLoading]=useState(false);
  const dataSubmit=async(e)=>{
    e.preventDefault();
    setLoading(true);
    await axios.post(`${process.env.REACT_APP_BASE_URL}/priceConverter/createPriceConverter`,formData);
    setFormData({});
    setLoading(false);
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          action=""
          onSubmit={dataSubmit}
        >
          <div style={{ padding: "5px" }}>
            <div style={{ display: "flex", gap: "40px" }}>
              <TextField
                id="outlined-basic"
                name="from"
                sx={{ width: "20vw" }}
                label="From*"
                variant="outlined"
                value={formData.from}
                onChange={(e)=>setFormData({...formData,[e.target.name]:e.target.value})}
              />
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="To*"
                name="to"
                variant="outlined"
                value={formData.to}
                onChange={(e)=>setFormData({...formData,[e.target.name]:e.target.value})}

              />
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Price*"
                name="price"
                variant="outlined"
                value={formData.region}
                onChange={(e)=>setFormData({...formData,[e.target.name]:e.target.value})}

              />
             
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10vh",
            }}
          >
            {/* <Button title={"Submit"} /> */}
            <button variant="contained" style={{
          color: "white",
          padding: "10px",
          cursor: "pointer",
          border: "none",
          outline: "none",
          background: "crimson",
          borderRadius: "5px",
        }} >
      {isLoading ? (
        <>
          <CircularProgress color="inherit"  size={14} sx={{color:"white"}} />
          Submit
        </>
      ) : (
        "Submit"
      )}
    </button>
              
          </div>
        </form>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddNewPrice;
